import(/* webpackMode: "eager" */ "/codebuild/output/src221508106/src/dharmayana-website/src/app/(pages)/terms-and-conditions/page.tsx");
